import { Operacao } from '../../@types';
import { OperacoesService } from '../../services';
import getSaveErrorMessage from '../../utils/error-message';

const messages = {};

export const getMessagesOperacoes = (
  error: unknown,
  status: 'create' | 'edit',
): string => getSaveErrorMessage(error, status, messages);

export const convertOperacoesToList = (data: Operacao[]) =>
  data.map((operacao) => ({
    ...operacao,
    humanizedTipo:
      OperacoesService.STATUS_OPERACOES_HUMANIZED[operacao.statusOperacao],
  }));
